var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/util/get-websocket-auth-message.ts
import { Auth } from "@leagueplatform/auth";
import {
  getLegacyAuthValues,
  hasLegacyAuthValues
} from "@leagueplatform/auth-legacy";
function getLegacyAuthAuthenticateMessage() {
  const { sessionId, deviceToken } = getLegacyAuthValues();
  return {
    message_type: "authenticate",
    info: { session_id: sessionId, device_token: deviceToken }
  };
}
function getAuthMessage() {
  return __async(this, null, function* () {
    const token = yield Auth.getToken();
    return {
      message_type: "authenticate_jwt",
      info: { jwt: token, api_version: 1 }
    };
  });
}
function getWebsocketAuthMessage() {
  return __async(this, null, function* () {
    if (Auth.initialized) {
      return getAuthMessage();
    }
    if (hasLegacyAuthValues()) {
      return getLegacyAuthAuthenticateMessage();
    }
    throw new Error(
      "unable to retrieve auth state for websocket; make sure you call StandaloneAuth.initialize"
    );
  });
}

// src/league-socket-as-promised.ts
import * as uuid from "uuid";
import WebSocketAsPromised from "websocket-as-promised";
var _currentAuthState;
var LeagueSocketAsPromised = class extends WebSocketAsPromised {
  constructor(url) {
    super(url, {
      createWebSocket: (address) => new WebSocket(address),
      packMessage: JSON.stringify,
      unpackMessage: (data) => JSON.parse(data),
      attachRequestId: (data, message_id) => __spreadProps(__spreadValues({}, data), { message_id }),
      extractRequestId: (data) => data == null ? void 0 : data.message_id
    });
    __privateAdd(this, _currentAuthState, "");
  }
  authenticate() {
    return __async(this, null, function* () {
      const authMessage = yield getWebsocketAuthMessage();
      yield this.sendRequest(authMessage, {
        requestId: uuid.v4()
      });
      __privateSet(this, _currentAuthState, JSON.stringify(authMessage.info));
    });
  }
  authenticateIfNeeded() {
    return __async(this, null, function* () {
      const authMessage = yield getWebsocketAuthMessage();
      if (__privateGet(this, _currentAuthState) !== JSON.stringify(authMessage.info)) {
        yield this.authenticate();
      }
    });
  }
};
_currentAuthState = new WeakMap();

// src/league-reconnecting-socket.ts
import ReconnectingWebSocket from "reconnecting-websocket";
var LeagueReconnectingSocket = class extends ReconnectingWebSocket {
  constructor(urlProvider) {
    super(urlProvider, "", { startClosed: true });
    this.currentAuthState = "";
    this.addEventListener("open", () => {
      this.authenticate();
    });
    this.addEventListener("message", (message) => {
      const unpackedMessage = JSON.parse(message.data);
      if (unpackedMessage.message_type === "authenticated") {
        this.updateAuth();
      }
    });
  }
  authenticate() {
    return __async(this, null, function* () {
      const authMessage = yield getWebsocketAuthMessage();
      if (this.currentAuthState !== JSON.stringify(authMessage.info)) {
        this.send(JSON.stringify(authMessage));
      }
    });
  }
  updateAuth() {
    return __async(this, null, function* () {
      const authMessage = yield getWebsocketAuthMessage();
      this.currentAuthState = JSON.stringify(authMessage.info);
    });
  }
};

// src/reconnecting-socket-controller.ts
var ReconnectingSocketControllerClass = class {
  constructor() {
    this.API_URL = "";
    this.activeHandlerCount = 0;
    this.urlProvider = () => this.API_URL;
  }
  init(url) {
    this.API_URL = url;
    if (this.instance) {
      console.warn(
        `Reconnecting Socket Controller has already been initialized with ${this.instance.url}. Calling init again will now connect to ${this.API_URL}`
      );
      if (this.activeHandlerCount > 0) {
        this.instance.reconnect();
      }
    } else {
      this.instance = new LeagueReconnectingSocket(this.urlProvider);
    }
  }
  addEventHandler(listener) {
    if (!this.instance) {
      throw Error(`Reconnecting WebSocket has not been initialized`);
    }
    const eventHandler = (message) => {
      const unpackedMessage = JSON.parse(message.data);
      listener(unpackedMessage);
    };
    this.instance.addEventListener("message", eventHandler);
    this.activeHandlerCount += 1;
    this.instance.reconnect();
    return () => this.removeEventHandler(eventHandler);
  }
  removeEventHandler(eventHandler) {
    var _a, _b, _c;
    if (
      // eslint-disable-next-line @typescript-eslint/dot-notation
      !((_a = this == null ? void 0 : this.instance) == null ? void 0 : _a["_listeners"]["message"].find(
        (l) => l === eventHandler
      ))
    ) {
      console.warn(
        `Event Handler does not exist or has already been removed from ReconnectingSocketController`
      );
      return;
    }
    (_b = this.instance) == null ? void 0 : _b.removeEventListener("message", eventHandler);
    this.activeHandlerCount -= 1;
    if (this.activeHandlerCount === 0) {
      (_c = this.instance) == null ? void 0 : _c.close();
    }
  }
  destroy() {
    var _a;
    (_a = this.instance) == null ? void 0 : _a.close();
    this.instance = void 0;
    this.activeHandlerCount = 0;
  }
};
var ReconnectingSocketController = new ReconnectingSocketControllerClass();
export {
  LeagueSocketAsPromised,
  ReconnectingSocketController
};
//# sourceMappingURL=index.js.map